<div class="admin-budget-setup">
    <cv-loader [size]="'large'" [overlay]="false" *ngIf="isLoading || isSaving"></cv-loader>
    <cv-admin-budget-title-header [title]="sectionTitle" [btnTemplate]="exportBtn"></cv-admin-budget-title-header>
    <ng-template #exportBtn>
        <div>
            <sol-button id="export-btn" [disabled]="isLoading" variant="basic" size="medium" [matMenuTriggerFor]="menu.menu">
                <span cvLocalizedText langSection="Budget_Setup" langKey="Export">Export</span>
            </sol-button>
            <sol-floating-menu #menu menuClass="export-budget" [menuItems]="defaultMenuOptions" 
                spriteIconPath="../App_Themes/CXone/icons/export-menu-icons.svg" position="'bottom'"></sol-floating-menu>
        </div>
    </ng-template>
    <div class="admin-budget-setup__legend" [ngClass]="{'pb-16': editMode}">
        <span>{{budgetPeriodMessage}}</span>
    </div>
    <div class="admin-budget-setup__opc-container">
        <sol-button class="admin-budget-setup__opc-change-budget-btn" variant="basic" size="large"
            *ngIf="editMode;else budgetSetup" (click)="changeBudget()">
            <span cvLocalizedText langSection="Budget_Setup" langKey="Change_Budget">Change Budget</span>
        </sol-button>
        <ng-template #budgetSetup>
            <sol-inline-notification class="admin-budget-setup__opc-notification" type="warning" [show]="true"
                [showClose]="true" [message]="messageNotification"></sol-inline-notification>
            <div class="row admin-budget-setup__opc-filter-save">
                <div class="col-12 col-md-10">
                    <div>
                        <label class="admin-budget-setup__opc-label" for="group" cvLocalizedText langSection="Budget_Setup"
                        langKey="Select_Group">Select
                        Group</label>
                    <sol-dropdown #groupDropdown id="group" name="group" class="admin-budget-setup__opc-group"
                        [(ngModel)]="groupType" [optionsLabel]="'LocalizedName'" [optionsValue]="'GroupLevel'"
                        [isMultiple]="false" [options]="groups" (selectionChange)="onSelectGroupLevel($event)">
                    </sol-dropdown>
                    </div>
                </div>
                <div class="col-12 col-md-2 d-flex align-items-center justify-content-md-end pt-3 pt-md-0 align-self-stretch">
                        <sol-button class="admin-budget-setup__opc-cancel-btn" variant="basic" size="medium"
                        (click)="cancel()">
                        <span cvLocalizedText langSection="Budget_Setup" langKey="Cancel">Cancel</span>
                    </sol-button>
                    <sol-button class="admin-budget-setup__opc-save-btn" variant="primary" size="medium"
                        [disabled]="isSaving" (click)="save()">
                        <span cvLocalizedText langSection="Budget_Setup" langKey="Apply">Apply</span>
                    </sol-button>
                </div>
            </div>
        </ng-template>
    </div>

    <div class="admin-budget-setup__empty-state d-flex justify-content-center flex-column align-items-center w-100"
        *ngIf="this.budget.budgetList.length === 0;else budgetContainer">
        <svg class="mb-2" style="width: 240px !important;">
            <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
        </svg>
        <span class="admin-budget-setup__empty-state-text" cvLocalizedText langSection="Budget_Setup"
            langKey="Empty_State">You don't have any active groups selected. Check your group
            settings to create a new budget!</span>
    </div>

    <ng-template #budgetContainer>
        <div class="admin-budget-setup__team-container mt-3 col-12 col-md-9 col-lg-8 col-xl-7 col-xxl-5 px-0">
            <div class="admin-budget-setup__team-header d-flex align-items-center row">
                <div class="col-4 col-md-5">
                    <span>{{groupTypeName}}</span>
                </div>
                <div class="col-8 col-md-7">
                    <span class="admin-budget-setup__distribution-label px-3" cvLocalizedText langSection="Budget_Setup"
                        langKey="Budget_Distribution">Budget distribution</span>
                </div>
            </div>
            <div [formGroup]="budgetForm">
                <div formArrayName="items">
                    <div class="admin-budget-setup__team-details d-flex align-items-center row"
                        *ngFor="let itemBudget of items.controls; let i = index" [formGroupName]="i">
                        <div class="col-4 col-md-5">
                            <span class="admin-budget-setup__team-name">{{budget.budgetList[i]?.GroupLevelName}}</span>
                        </div>
                        <div class="col-8 col-md-7 d-flex align-items-center admin-budget-setup__input-container">
                            <div class="col-8 pr-0">
                                <sol-text-input type="text" formControlName="AmountString" [leadingIcon]="coin"
                                class="w-100" (input)="formatNumber($event, i, items.at(i).get('AmountString'))" />
                            <ng-template #coin>
                                <svg class="icon-16"
                                    [ngClass]="{'disabled-icon': editMode, 'enabled-icon': !editMode }">
                                    <use href="../App_Themes/CXone/icons/gamification/coin-disabled.svg#coin-disabled">
                                    </use>
                                </svg>
                            </ng-template>
                            </div>
                            <div class="col-4 px-0">
                                <span class="admin-budget-setup__coin-label mt-1" cvLocalizedText langSection="Budget_Setup"
                                langKey="Coins">Coins</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="admin-budget-setup__total-budget d-flex align-items-center row">
                <div class="col-4 col-md-5">
                    <span cvLocalizedText langSection="Budget_Setup" langKey="Total_Budget">Total budget</span>
                </div>
                <div class="col-8 col-md-7 d-flex align-items-center">
                    <div class="col-8 text-right pr-0">
                        <span class="admin-budget-setup__total-label">{{budget.total}}</span>
                    </div>
                    <div class="col-4 px-0">
                        <span cvLocalizedText langSection="Budget_Setup" langKey="Coins" class="admin-budget-setup__total-coin-label">Coins</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>